import { HttpClient } from '../../../application/protocols/http-client';
import { AxiosHttpClientAdapter } from './axios-http-client-adapter';

export const httpClient: HttpClient = new AxiosHttpClientAdapter();
